/** @flow */

export default {
  en: {
    RESUME_FILE_LOAD: "Resume File Load",
    RESUME: "Resume",
    LOAD_NEW_DATA: "Load New Data",
    UPLOADING: "File is being uploaded",
    LOAD_NEW_DATA_DESCRIPTION: "Import new records to the database",
    LOAD_DATA: "Load Data",
    SIP_FILE_ARCHIVE: "Sip File Archive",
    EXPORT_DATA: "Export Data",
    EXPORT_CURRENT_DATA: "Export Current Data",
    EXPORT_CURRENT_DATA_DESCRIPTION:
      "Export Hierarchy Data, Staff In Post, Historic, Historic Absence Data or GoodShapeCentral! Accounts",
    EXCHANGE_DATA: "Exchange Data",
    TRANSFER_FILES: "Transfer Files",
    DATA_IMPORT: "Data Import",
    DATA_EXPORT: "Data Export",
    EXPORT_HISTORY: "Export History",
    DATA_QUALITY: "Data Quality",
    ORG_STRUCTURE: "Org Structure",
    DATA_TRANSFER: "Data Transfer",
    LOAD_AND_EXPORT_SIP_FILES: "Load And Export SIP Files",
    SECURE_FILE_TRANSFER: "Secure File Transfer",
    SECURE_FILE_TRANSFER_INFO:
      "Data files often contain sensitive information.<br  />Please ensure that any files you transfer only contain relevant and appropriate data.",
    SECURE_FILE_TRANSFER_PAGE_INFO:
      "This page can be used to securely transfer a file to and from GoodShape. Note that any transferred files will be available to any Admin and Data Transfer users. If you transfer a file by mistake, it can be removed by clicking on the Delete button to the right. Supported file types are: XLS, XLSX and CSV. Files are only retained for a period of 6 months.",
    EXPORT_FILE: "Export a File",
    TRANSFER_HISTORY: "Transfer History",
    TRANSFER_FILE_HISTORY: "Transfer File History",
    TRANSFER_DATA_ARCHIVE: "Transfer Data Archive",
    TRANSFER_ARCHIVE_EXPIRATION_WARNING: "Transferred files will only be retained for 6 months.",
    HELP_AND_SUPPORT: "Help & Support",
    FIELD_GUIDE: "Field Guide",
    EXCEPTIONS_GUIDE: "Exceptions Guide",
    TROUBLESHOOTING: "Troubleshooting",
    SIP_FILE_ARCHIVE: "SIP File Archive",
    DATA_FILE_ARCHIVE_DESCRIPTION:
      "View a list of historic files that have been processed or cancelled",
    VIEW_ARCHIVE: "View Archive",
    LAST_EDITED_BY: "Last Edited By",
    FILE_TYPE: "File Type",
    LOAD_NEW_DATA_DISABLED_WARNING:
      "Loading of new data is disabled as there’s a prior import exceptions review in progress.",
    FILTER_DATA_TYPE: "Data Type",
    HIERARCHY_LOAD: "Hierarchy Load",
    STAFF_IN_POST: "Staff in Post",
    HISTORIC_ABSENCE: "Historic Absence",
    PROCESSED: "Processed",
    CANCELLED: "Cancelled",
    COLUMN_FILE_ID: "File ID",
    COLUMN_DATE_LOADED: "Date Loaded",
    COLUMN_LOADED_BY: "Loaded By",
    COLUMN_DATA_TYPE: "Data Type",
    COLUMN_HIERARCHY_AREA: "Hierarchy Area",
    COLUMN_TOTAL_DATA_ROWS: "Total Data Rows",
    COLUMN_TOTAL_CHANGES: "Total Changes",
    COLUMN_TOTAL_EXCEPTIONS: "Total Exceptions",
    COLUMN_STATUS: "Status",
    CHANGE_TYPE_ID: "Change Type ID",
    CHANGE_NAME: "Change Name",
    VIEW_DETAILS: "View Details",
    LAST_WORKED_ON: "Last Worked on",
    RESUME_CURRENT_DATA: "Resume Current Data",
    HISTORIC_ABSENCE_DATA_EXCEPTIONS: "Historic Data Exceptions",
    STAFF_IN_POST_DATA_EXCEPTIONS: "Staff in Post Data Exceptions",
    HIERARCHY_LOAD_DATA_EXCEPTIONS: "Hierarchy Data Exceptions",
    MY_FIRSTCARE_ACCOUNTS_LOAD_DATA_EXCEPTIONS: "My GoodShape accounts Data Exceptions",
    ABANDON: "Abandon",
    CONFIRM_SELECTION: "Confirm selection",
    CONFIRM_DATA_TO_BE_BLOCKED: "Confirm Data to be Blocked",
    EXCEPTION_TYPE_MSG_BLOCKED:
      "All records in this section will be blocked. Please review and confirm.",
    EXCEPTION_TYPE_MSG_MANUAL:
      "Review and select the records which you would like to allow to go through. The rest will be blocked.",
    EXCEPTION_TYPE_MSG_USER_ACKNOWLEDGMENT:
      "All records in this section will be allowed through. Please review and acknowledge.",
    EXCEPTION_TYPE_MSG_INCORRECT_PHONE_NUMBER:
      "All mobile numbers in this section will be blocked. Please review and acknowledge.",
    EXIT: "Exit",
    PROCESS_FILE: "Process File",
    SELECTED_EXCEPTIONS: "{value} selected",
    DESELECT_ALL: "Deselect all",
    FILE_STATUS: "File Status",
    VALIDATING_FILE_FAILED: "Validating File Failed",
    VALIDATING_FILE_FAILED_WARNING:
      "Failed to validate imported file. Please delete file and import again",
    ROW: "Row",
    EXCEPTION_DETAILS: "Exception Details",
    LAST_CHANGES: "Manual change made in the last 24 hours",
    ACKNOWLEDGE_AND_CONTINUE: "Acknowledge and Continue",
    USE_DEFAULT: "Use Default ({value}) ",
    SELECTED_EXCEPTIONS_SUMMARY: "{blocked} blocked and {allowed} allowed to go through",
    DEPARTMENT_REF: "Department Ref",
    Department: "Department",
    DIRECTORATE: "Directorate",
    POSITION_START_LESS_DOB: "Position Start < DOB",
    EMPLOYMENT_START_LESS_DOB: "Employment Start < DOB",
    UNSAVED_CHANGES: "Unsaved Changes",
    UNSAVED_CHANGES_TEXT:
      "There are unsaved changes in the currently open section. \n" +
      "Would you like to save or discard them?",
    DISCARD_CHANGES: "Discard Changes",
    FILE_CHANGES_SUMMARY: "File Changes Summary",
    FILE_CHANGES_DETAILS: "File Changes Details",
    SELECT_TYPE_ON_PAGE: "{type} All on Page",
    SELECT_TOTAL_EXCEPTIONS: "{type} All ({total})",
    TODAYS_DATE: "Todays Date",
    MOVED_TO_UNASSIGNED: "Move to Unassigned",
    NO_ASSIGNMENT: "Continue without Assignment",
    CLOSE_ABSENCES: "Close Absences",
    PROCESSING_FILE: "Processing File",
    PROCESSING_FAILED: "Processing Failed",
    PROCESSING: "Processing",
    LOADING: "Loading",
    VALIDATING: "Validating",
    VALIDATING_SIP_FILE: "Validating SIP file",
    QUEUED: "Queued",
    QUEUE_FILE_SUBMITTED_BY: "File Submitted by {name} on {date}",
    QUEUE_CURRENT_POSITION: "Current Queue Position: {position}",
    YOU_ARE_NEXT: "You are next",
    UPLOADING_PLEASE_WAIT: "Uploading, please wait... ",
    VIEW_EXCEPTIONS: "View Exceptions",
    COMPLETE: "Complete",
    IN_PROGRESS: "In Progress",
    CANCEL_PROCESSING: "Cancel Processing",
    EMPLOYEES_RECORDS: "Employees Records",
    EXPORT_STATUS: "Export Status",
    OFFLINE_EXPORT_QUEUED_INFO:
      "Due to the size of the SIP File, your Export will be queued for processing. " +
      "An email will be sent to you once the export is available. " +
      "The export will appear in the History table below for you to click and download.",
    OFFLINE_EXPORT_CONFIRM_QUESTION: "Do you wish to continue with the export?",
    NO_CANCEL_EXPORT: "No, Cancel Export",
    YES_PROCESS_EXPORT: "Yes, Process Export",
    DIRECT_EXPORT: "Direct Export",
    READY: "Ready",
    DATE_EXPORTED: "Date Exported",
    EXPORT_ID: "Export ID",
    EXPORTED_BY: "Exported By",
    HIERARCHY_AREA: "Hierarchy Area",
    DONE: "DONE",
    PENDING: "Pending",
    UPDATING_EMPLOYEES: "Updating Employee Details",
    UPDATING_POSITIONS_AND_NOTIFICATIONS: "Updating Notification Contacts",
    PROCESSING_PAST_OR_CURRENT_LEAVERS_WITH_OPEN_ABSENCES: "Processing Leavers with Open Absences",
    PROCESSING_FUTURE_LEAVERS: "Processing Future Leavers",
    PREPARING_DATA_IMPORT_FILE_TO_BE_PROCESSED: "Preparing data",
    NOT_STARTED: "NOT STARTED",
    FAILED: "Failed",
    FILE_ID: "File Id",
    DATE_TRANSFERRED: "Date Transferred",
    TRANSFERRED_BY: "Transferred By",
    PLEASE_WAIT: "Please wait, your file is being prepared for download",
    SET_LEAVE_DATE_AND_MARK_POSITIONS_INACTIVE: "Mark employee leaver and its positions inactive",
    DATA_QUALITY_ISSUES: "Data Quality Issues",
    TOTAL_DATA_MEASURES: "Total Data Measures",
    DATA_MEASURES_IN_GOOD_HEALTH: "Data Measures in Good Health",
    DATA_MEASURES_IN_MIXED_HEALTH: "Data Measures in Mixed Health",
    DATA_MEASURES_IN_POOR_HEALTH: "Data Measures in Poor Health",
    DATA_QUALITY_MEASURES: "Data Quality Measures",
    QUANTITY: "Quantity",
    STATUS: "Status",
    IMPACT: "Impact",

    // EXCEPTIONS TYPES
    MISSING_EMPLOYEE_REFERENCE: "Missing Employee Ref",
    MISSING_FIRST_NAME: "Missing First Name",
    MISSING_SURNAME: "Missing Surname",
    MISSING_DATE_OF_BIRTH: "Missing Date Of Birth",
    MISSING_CONTRACTED_HOURS: "Missing Contracted Hours",
    MISSING_WORKING_DAYS: "Missing Working Days",
    MISSING_NOTIFICATION_CONTACTS: "Missing Notification Contacts",
    MISSING: "Missing",
    DUPLICATE_EMPLOYEE_REFERENCE: "Duplicate Employee Ref",
    DUPLICATE_EMAIL_ADDRESS: "Duplicate Email Address",
    DUPLICATE_POSITION: "Duplicate Position",
    INVALID_EMAIL_DOMAIN: "Invalid Email Domain",
    INVALID_EMAIL_ADDRESS: "Invalid Email Address",
    DATE_JOINED_ORGANISATION_EARLIER_THAN_DOB: "Date Joined Organisation Earlier Than DOB",
    DATE_OF_EMPLOYMENT_END_IS_EARLIER_THAN_EMPLOYMENT_START_DATE:
      "Date of Employment End Is Earlier Than Employment Start Date",
    POSITION_END_DATE_IS_EARLIER_THAN_POSITION_START_DATE:
      "Position End Date Is Earlier than Position Start Date",
    UNABLE_TO_ALLOCATE_DEPARTMENT: "Unable To Allocate Department",
    UNABLE_TO_ALLOCATE_STAFF_GROUP: "Unable To Allocate Staff Group",
    UNABLE_TO_ALLOCATE_SHIFT_PATTERN: "Unable To Allocate Shift Pattern",
    PAST_OR_CURRENT_LEAVERS_WITH_OPEN_ABSENCE: "Past Or Current Leavers With Open Absence",
    NOTIFICATION_CONTACT_DOES_NOT_EXIST: "Notification Contact Does Not Exist",
    NOTIFICATION_CONTACT_IS_A_LEAVER: "Notification Contact Is A Leaver",
    NOTIFICATION_CONTACT_DOES_NOT_HAVE_AN_EMAIL_ADDRESS:
      "Notification Contact Does Not Have An Email Address",
    POTENTIAL_LEAVERS: "Potential Leavers",
    POTENTIAL_INCORRECT_WORKING_DAYS: "Potential Incorrect Working Days",
    POTENTIAL_INCORRECT_CONTRACTED_HOURS: "Potential Incorrect Contracted Hours",
    POTENTIAL_INCORRECT_DATE_OF_BIRTH: "Potential Incorrect Date Of Birth",
    POTENTIAL_INCORRECT_PHONE_NUMBER: "Potential Incorrect Phone Number",
    EMAIL_ADDRESS_THAT_WILL_BE_DELETED: "Warning: Email Address That Will be Deleted",
    MOBILE_NUMBERS_THAT_WILL_BE_DELETED: "Warning: Mobile Numbers That Will be Deleted",
    FUTURE_LEAVERS_WITH_OPEN_ABSENCE: "Future Leavers With Open Absence",
    EMAIL_ADDRESS_NOT_PERMITTED: "Email Address Not Permitted",
    POSITION_START_DATE_NOT_ALLOWED_TO_BE_UPDATED: "Position Start Date Has Changed",
    DUPLICATE_POSITION_IN_SAME_DEPARTMENT: "Duplicate Position in Same Department",
    MISSING_EMPLOYMENT_START_DATE: "Missing Employment Start Date",

    // labels
    EMPLOYEE_SURNAME: "Surname Update",
    EMPLOYEE_FIRST_NAME: "First Name Update",
    POSITION_DEPARTMENT: "Department Move",
    EMPLOYEE_EMAIL_ADDRESS: "Email Update",
    EMPLOYEE_PHONE_NUMBER: "Phone Number Update",
    POSITION_CONTRACTED_HOURS: "Contract Hours Update",
    POSITION_WORKING_DAYS: "Working Days Update",
    POSITION_STAFF_GROUP: "Staff Group",
    POSITION_SHIFT_PATTERN: "Shift Pattern",
    EMPLOYEE_LEAVING_DATE: "Leaver",
    EMPLOYEE_ADDED: "New Starter",
    MUST_BE_XLS_XLSX_CSV: "Must be XLS, XLSX or CSV",
    EXPORT_DATA_ARCHIVE: "Export Data Archive",
    NOTIFICATION_CONTACT_ADDED: "Added Notification Contacts",
    NOTIFICATION_CONTACT_REMOVED: "Removed Notification Contacts",
    NOTIFICATION_CONTACT_TYPE: "Updated Notification Type",
    RECORD: "Record",
    OLD_VALUE: "Old Value",
    NEW_VALUE: "New Value",
    MISSING_POSITION_REF: "Missing Position Ref",

    NO_FILE_LINE_1: "Need to load a new SIP file?",
    NO_FILE_LINE_2: "Get started by clicking the Load New Data button below.",
    LOADING_LINE_1: "Your file is currently being uploaded to the system.",
    LOADING_LINE_2: "Validation of the file will commence automatically once loaded.",
    VALIDATING_LINE_1:
      "Your file is currently being validated to verify it is in an acceptable format.",
    VALIDATING_LINE_2:
      "If your file fails validation please consult with the Troubleshooting Guide in the Help & Support section.",
    PENDING_LINE_1: "Your file has successfully been validated.",
    PENDING_LINE_2: "Click the Resume button to review and manage the identified exceptions.",
    QUEUED_LINE_1: "Validation of the SIP File has successfully completed.",
    QUEUED_LINE_2:
      "Processing will take place automatically and you can safely navigate to another page if you wish.",
    PROCESSING_LINE_1: "Your File is currently processing.",
    PROCESSING_LINE_2: "The table below will automatically update as it progresses.",
    COMPLETE_LINE_1: "Your SIP File has been processed successfully.",
    COMPLETE_LINE_2: "You can now close this section.",
    DATA_EMPLOYEE_DATA_INFORMATION:
      "Staff In Post files contain a significant amount of employee data.",
    DATA_EXPORT_WARNING: "Only continue with this Export if it is absolutely necessary.",
    DATA_SAFE_LOCATION_WARNING: "Please ensure that you store it in a safe location.",
    DATA_EXPORT_MONITORING_INFORMATION:
      "Staff in Post exports are logged for security and auditing purposes.",
    DATA_UPLOAD_NOTICE:
      "Staff In Post files contain a significant amount of employee data. The data in your file will update the data on GoodShapeCentral. Please ensure that the data in your file is correct before loading it. Uploaded SIP files will only be retained and available to download for 6 months.",

    // Data Admin Help Panel
    DATA_ADMIN_INTRODUCTION:
      "The Data Admin page lets you upload, export and transfer data via GoodShapeCentral. It plays a crucial role in maintaining the platform and enables you to keep all employee and notification data up-to-date.",
    LOADING_DATA: "Loading Data",
    EXCEPTIONS: "Exceptions",

    LOADING_DESCRIPTION:
      "This section enables you to load a new SIP file into the system. When you click the button you will be prompted to select a file from your device, confirm the hierarchy scope of the update, and then press Submit.",
    VALIDATING_DESCRIPTION:
      "When a SIP file is loaded into the system, the data it contains is submitted to a series of validation checks. There are 30+ checks on each employee record. The greater the number of employees in your file, the longer this step of the process will take.",
    PENDING_DESCRIPTION:
      'Once the validation check is complete, your SIP File moves into a "Pending" status. At this point you can either Cancel the process, or click Resume to view any data issues that have been found in your file.',
    EXCEPTIONS_DESCRIPTION:
      "Data Issues (referred to as Exceptions) will be presented to you in a pop-up. You will need to review, or resolve, all exceptions before you can continue the process. Alternatively, you can abandon and cancel the submission if you prefer.",
    QUEUED_DESCRIPTION:
      "When you submit your SIP file it will go into a queue to be processed. Your position in the queue will be shown on screen.",
    PROCESSING_DESCRIPTION:
      "When your file gets to the front of the queue, it will begin processing. Employee details are updated first, then Notification Contacts, then Leavers who have an Open Absence, then Future Leavers.",
    COMPLETE_DESCRIPTION:
      "Once the data load process is complete, you will be informed. You can then close the screen. A log of the processed file will be added to the File Archive at the bottom of the page.",
    EXPORTING_DATA: "Exporting Data",
    EXPORT_DESCRIPTION:
      "You can export the SIP file for any area of your organisation. Note that a log of this action is maintained for auditing purposes.",
    ARCHIVE_DESCRIPTION:
      "Viewing the Export archive will enable you to see a list of exports, who performed them and when.",
    TRANSFERRING_DATA: "Transferring Data",
    TRANSFERRING_DATA_DESCRIPTION:
      'You can transfer a data file to GoodShape by clicking on the "Choose File" button. This enables you to select a file on your device and upload it to GoodShapeCentral securely.',
    TRANSFERRING_ARCHIVE_DESCRIPTION:
      "Viewing the Transfer archive will enable you to view and download all previously transferred files. You can also delete any uploaded files that you no longer want to be available.",
    DATA_SUMMARY: "Data Summary",
    SIP_FILE_ARCHIVE_DESCRIPTION:
      "This table lists the SIP Files that have been processed for your organisation. The unique file ID, the date it was processed and the name of the user that processed it are all shown.",
    DATA_SUMMARY_DESCRIPTION:
      "A count of how many employees appeared in the file is shown, as well as the total number of changes made, and exceptions that were flagged.",
    SIP_FILE_VIEW_DESCRIPTION:
      "Clicking View will enable you to see a summary of the key changes that were made to employee data when the file was processed.",
    SIP_FILE_DOWNLOAD_DESCRIPTION:
      "Clicking the Download button will export the SIP file to Excel so you can see a copy of the original file that was processed at the time.",
    SIP_FILES_FIELD_GUIDE: "Tutorial: Field Guide",
    SIP_FILES_NEW_STARTERS: "Tutorial: Adding New Starters",
    SIP_FILES_LEAVERS_REMOVING: "Tutorial: Removing Leavers",
    SIP_FILES_POSITION_AND_DEPARTMENT_UPDATES: "Tutorial: Position Updates & Department Moves",
    DATA_ADMIN_INSTRUCTIONS: "Data Admin Instructions",

    // SIP Files
    ALLOW: "Allow",
    "37.5_HRS": "37.5 hrs",
    MAKE_INACTIVE: "Make Inactive",
    REVIEW_THE_EXCEPTIONS: "Please review the exceptions below:",
    MISSING_DATE_OF_BIRTH_WARNING:
      "These records have no date of birth on the SIP file. All changes to them are now blocked. To resolve this issue, locate the corresponding row/s on the SIP file and add a date of birth. It must be in a DD/MM/YYYY format.",
    UNABLE_TO_ALLOCATE_SHIFT_PATTERN_WARNING:
      "These records have a Shift Pattern on the SIP File that does not exist on GoodShapeCentral. As a result, they will be ignored when your file is processed. If these Shift Patterns are needed, you must first add them via the {link} admin page and then re-submit your file.",
    NOTIFICATION_CONTACT_DOES_NOT_EXIST_WARNING:
      "These records have a notification contact that can't be found. You must locate the corresponding row/s on the SIP file and update the notification contact details to match a record on the SIP or GoodShapeCentral. Save the updated file and then upload it again.",
    POTENTIAL_LEAVERS_WARNING:
      "These employees are on GoodShapeCentral but do not appear in the SIP File. Use the checkbox on the left to leave them as an active record, or the checkbox on the right to make them inactive as of today's date.",
    MISSING_CONTRACTED_HOURS_WARNING:
      "These employees have no contracted hours on the SIP file. All changes to them are now blocked. Your options are: 1) Update the SIP file to have the correct values and re-submit it, or 2) Use the checkbox on the right to add a default weekly hours value of 37.5 to the relevant employees.",
    MISSING_NOTIFICATION_CONTACTS_WARNING:
      "These records have no notification contacts in the SIP File. If this is expected, you can click Continue. If notification contacts are missing, you must add them to the SIP file and re-submit it. Alternatively, you can add them directly to the employee's record later.",
    POTENTIAL_INCORRECT_PHONE_NUMBER_WARNING:
      "These employees have a phone number that is not 11 digits in length, suggesting they may be incorrect. These numbers will therefore not be loaded into the system. You will need to add them manually via the Employee Admin screen.",
    EMAIL_ADDRESS_THAT_WILL_BE_DELETED_WARNING:
      "These employees have an email address on GoodShapeCentral that does not appear on the SIP File. Use the checkbox on the left to select which email addresses you would like to be deleted. Any unticked email addresses will remain on the system.",
    DUPLICATE_EMPLOYEE_REFERENCE_WARNING:
      "These employees do not have a unique reference number on the SIP file (i.e. it is assigned to 2+ employees). All changes to them are now blocked. You must locate the corresponding row/s on the SIP file and ensure that a unique reference number is listed for each employee.",
    INVALID_EMAIL_DOMAIN_WARNING:
      "These employees have an email address on the SIP file that uses a domain which is not permitted by your Security settings. All changes to them are now blocked. You must either change the email addresses or add the domains in {link} settings and re-submit your file.",
    DATE_JOINED_ORGANISATION_EARLIER_THAN_DOB_WARNING:
      "These employees have an employment start date before their date of birth. All changes to them are now blocked. To resolve this issue, locate the corresponding row/s on the SIP file and ensure the correct dates are listed in a DD/MM/YYYY format.",
    UNABLE_TO_ALLOCATE_DEPARTMENT_WARNING:
      "These records are assigned to a department on the SIP file that does not match to one in your hierarchy on GoodShapeCentral. All changes to them are now blocked. You must either fix the SIP file, or add a new department by visiting {link}.",
    NOTIFICATION_CONTACT_DOES_NOT_HAVE_AN_EMAIL_ADDRESS_WARNING:
      "These records have a notification contact listed on the SIP file who does not have an email address. All changes to them are now blocked. Your options are: 1) Locate the notification contact on the file and add an email address for them, or 2) Remove the notification contact from the employee.",
    POTENTIAL_INCORRECT_DATE_OF_BIRTH_WARNING:
      "These employees have a date of birth on the SIP file that means they are less than 16 years old, which is lower than expected. Use the checkbox on the left to select the employees whose date of birth you wish to apply despite this warning. Any unticked employees will not have their date of birth updated.",
    MOBILE_NUMBERS_THAT_WILL_BE_DELETED_WARNING:
      "These employees have a mobile phone number for notifications on GoodShapeCentral that does not appear on the SIP File. Use the checkbox on the left to select which phone numbers you would like to be deleted. Any unticked phone numbers will remain on the system.",
    DUPLICATE_POSITION_WARNING:
      "These employees do not have a unique position reference number on the SIP file. All changes to them are now blocked. To resolve this issue, locate the corresponding row/s on the SIP file and ensure that a unique position reference is listed.",
    NOTIFICATION_CONTACT_IS_A_LEAVER_WARNING:
      "These records have a notification contact that is a leaver (i.e. they have an employment end date in the past). You must locate the corresponding row/s on the SIP file and update the notification contact details. Save the updated file and then upload it again.",
    MISSING_FIRST_NAME_WARNING:
      "These records have no first name on the SIP file. All changes to them are now blocked.To resolve this issue, locate the corresponding row/s on the SIP file and add the first name. Save the updated file and then upload it again.",
    MISSING_SURNAME_WARNING:
      "These records have no surname on the SIP file. All changes to them are now blocked. To resolve this issue, locate the corresponding row/s on the SIP file and add a surname. Save the updated file and then upload it again.",
    MISSING_EMPLOYEE_REFERENCE_WARNING:
      "There records have no Employee Reference number in the SIP file. All changes to them are now blocked. To resolve this issue, locate the corresponding row/s on the SIP file and add a unique reference number. Save the updated file and then upload it again.",
    POSITION_END_DATE_IS_EARLIER_THAN_POSITION_START_DATE_WARNING:
      "These employees have a position end date before their start date. All changes to them are now blocked. To resolve this issue, locate the corresponding row/s on the SIP file and ensure the correct dates are listed.",
    DATE_OF_EMPLOYMENT_END_IS_EARLIER_THAN_EMPLOYMENT_START_DATE_WARNING:
      "These employees have a leaving date before their start date. All changes to them are now blocked. To resolve this issue, locate the corresponding row/s on the SIP file and ensure the correct dates are listed.",
    UNABLE_TO_ALLOCATE_STAFF_GROUP_WARNING:
      "These records have a Staff Group on the SIP File that does not exist on GoodShapeCentral. As a result, they will be ignored when your file is processed. If these Staff Groups are needed, you must first add them via the {link} admin page and then re-submit your file.",
    DUPLICATE_EMAIL_ADDRESS_WARNING:
      "These employees have a duplicate email address on the SIP file. All changes to them are now blocked. You must remove, or change, the email address for the identified records and re-submit the file.",
    PAST_OR_CURRENT_LEAVERS_WITH_OPEN_ABSENCE_WARNING:
      "These employees are marked as a leaver on the SIP File, but currently have an open absence on GoodShapeCentral. Use the checkbox on the left to leave their absence open, or the checkbox on the right to close down the absence.",
    POTENTIAL_INCORRECT_CONTRACTED_HOURS_WARNING:
      "These employees have weekly contracted hours of greater than 60 on the SIP file, which is higher than expected. Use the checkbox on the left to select the employees whose contracted hours you want to update despite this warning. Any unticked employees will retain their existing weekly contracted hours.",
    POSITION_START_DATE_NOT_ALLOWED_TO_BE_UPDATED_WARNING:
      "The Position Start Date of a record cannot be changed via the SIP file. If you want to change the position start dates of these employee records you must update their records directly on GoodShapeCentral.",
    DUPLICATE_POSITION_IN_SAME_DEPARTMENT_WARNING:
      "An employee cannot have two active positions in the same department at the same time. For each of these employees you will need to update the SIP file to either assign the employee's position to a new department, or use the Position Ref of their existing position to keep them in the same department.",
    POTENTIAL_RETURNER_WARNING:
      "The Employee Ref, First Name and Date of Birth of the employees below match existing, inactive records in the system. If these employees have returned to your organisation, you can re-activate their records by selecting them on the right. Any un-selected records will not be re-activated.",
    REVIEW_CHANGES_WARNING:
      "If the above changes are not in line with your expectations, we recommend Abandoning the process and double checking that your file contains the correct data.",
    REVIEW_CHANGES_PENDING_WARNING:
      "Your data file is being compared to the current data on GoodShapeCentral. A summary of the identified changes will soon be available for you to review. Depending on the size of your file, this process may take a few minutes.",
    REVIEW_CHANGES_OVERVIEW: "This {type} file is estimated to make the following changes:",
    REVIEW_CHANGES: "Review Changes",
    GENERATING_REVIEW: "Generating Review",
    IN_REVIEW: "In Review",
    SUBMIT_FOR_REVIEW: "Submit for Review",
    POTENTIAL_RETURNER: "Potential Returner",
    REVIEW: "Review",
  },
};
